
    <div class="option">
      <ng-content></ng-content>
    </div>
  